<app-series-dashboard-summary [portfolioSummary]="portfolioSummary()" [iconSet]="iconSet()"
  [selectedAsOfDate]="selectedAsOfDate()" (snapShotBtnClick)="getSnapshot()"
  [isPortfolioSeriesDataUnavailable]="isPortfolioSeriesDataUnavailable()"
  [seriesSummary]="seriesSummary()" [seriesName]="seriesNameForBreadcrumb()"></app-series-dashboard-summary>
<div class="grid grid-cols-1 lg:grid-cols-2 mt-4">
  <div class="lg:pr-7 pl-0" tourAnchor="series.dashboard.commitment.widget">
    <app-commitment-value-widget [widgets]="widgets()" [currency]="currency()" [displayTabs]="['strategy', 'investmentType', 'vintageYear']"></app-commitment-value-widget>
  </div>
  <div class="pl-0 mt-4 lg:mt-0 lg:ml-0" tourAnchor="series.dashboard.remaining.widget">
    <app-remaining-value-widget [widgets]="widgets()" [displayTabs]="['geography', 'sectors', 'assetStatus']"
      [currency]="currency()" [otherSectorNames]="otherSectorNames()" />
  </div>
</div>
<app-key-performance-widget [widgets]="widgets()" [currency]="currency()"></app-key-performance-widget>
@if(isAggregatedSeries()) {
  @for(series of summary()?.underlyingPortfolioSeries; track series.masterId; let i = $index) {
    <div class="pt-6 text-2xl font-bold" attr.data-cy="underlyingSeriesName{{i}}">
      {{series.name}}
    </div>
    <div class="pb-3" attr.data-cy="underlyingSeriesSummaryCard{{i}}">
      <app-series-summary-card [iconSet]="iconSet()" [currency]="currency()" [seriesSummary]="series"></app-series-summary-card>
      <div class="flex justify-center relative -mt-2">
        <img class="expand-collapse-icon-series" data-cy="expandCollapseIconAggSeries"
            (click)="series.isCollapsed = !series.isCollapsed"
            (keydown.enter)="series.isCollapsed = !series.isCollapsed"
            (keydown.space)="series.isCollapsed = !series.isCollapsed"
            tabindex="0"
            role="button"
            alt="{{ !series.isCollapsed ? 'Collapse series' : 'Expand series' }}"
          src="{{ !series.isCollapsed ? iconSet()['icon.series.collapse'] : iconSet()['icon.expand']}}">
        </div>
      </div>
      @if(!series.isCollapsed) {
        <app-series-deals-table [iconSet]="iconSet()" [investmentTypes]="investmentTypes()[series.masterId]"
          [summary]="series" [portfolioName]="portfolioSummary()?.name" [seriesName]="series.name"
          [currency]="currency()" [investorId]="investorId()" [seriesId]="series.masterId"
        [reportingPeriod]="series.reportingPeriod" [isAggregatedSeries]="isAggregatedSeries()"></app-series-deals-table>
        <app-series-qroll-table [iconSet]="iconSet()" [portfolioSummary]="portfolioSummary()"
          [summary]="series" [investmentTypes]="investmentTypes()[series.masterId]" [portfolioName]="portfolioSummary()?.name"
          [seriesName]="series.name" [investorId]="investorId()" [seriesId]="series.masterId"
        [reportingPeriod]="series.reportingPeriod" [isAggregatedSeries]="isAggregatedSeries()"></app-series-qroll-table>
      }
    }
  } @else {
    <app-series-deals-table [iconSet]="iconSet()" [investmentTypes]="investmentTypes()[$any(seriesId())]"
      [summary]="summary()" [portfolioName]="portfolioSummary()?.name" [seriesName]="seriesSummary()?.name"
      [currency]="currency()" [investorId]="investorId()" [seriesId]="seriesId()"
    [reportingPeriod]="reportingPeriod()" [isAggregatedSeries]="isAggregatedSeries()"></app-series-deals-table>
    <app-series-qroll-table [iconSet]="iconSet()" [portfolioSummary]="portfolioSummary()"
      [summary]="summary()" [investmentTypes]="investmentTypes()[$any(seriesId())]" [portfolioName]="portfolioSummary()?.name"
      [seriesName]="seriesSummary()?.name" [investorId]="investorId()" [seriesId]="seriesId()"
    [reportingPeriod]="reportingPeriod()" [isAggregatedSeries]="isAggregatedSeries()"></app-series-qroll-table>
  }
